module.exports = __webpack_public_path__ + "media/images/application/favicon/safari-pinned-tab-ce7343b6462a73d31b2ee8b35a4c8f6c.svg";